import {
  checkUserPrivileges,
  type SystemPrivilege,
} from '@/entities/authentication';
import { redirect } from '@tanstack/react-router';

export function privilegeGuardRoute({
  privileges,
  strict,
}: {
  privileges: SystemPrivilege[];
  strict?: boolean;
}) {
  if (!checkUserPrivileges(privileges, strict)) {
    throw redirect({ to: '/forbidden' });
  }
}
